// extracted by mini-css-extract-plugin
module.exports = {"outer":"du6l6","headerWrapper":"bYgSJ","heading":"_3elxt","blueCardWrapper":"ORc12","cardHeading":"_21uMI","cardSubHeading":"_1N8a6","greyCardWrapper":"_2xdh-"};